import { ROLE_REPORTING_ADMIN } from '~/consts/roles';

import isProd from '~/utils/isProd';

/**
 * CS leaders who see the page before the Reporting Admin role is granted to the CS team. Add the CS
 * leadership emails here once confirmed; the role covers everyone else.
 */
export const CS_DAILY_OPS_PILOT_EMAILS: ReadonlyArray<string> = [
  'jake.pajer@luxuryescapes.com',
  'koren.sela@luxuryescapes.com',
  'leopoldo.giovanetti@luxuryescapes.com',
  'ming.chong@luxuryescapes.com',
  'vanessa.kraut@luxuryescapes.com',
];

const pilot = new Set(CS_DAILY_OPS_PILOT_EMAILS);

export function isCsDailyOpsEnabled(
  user: { email?: string | null; roles?: Array<string> } | null | undefined,
): boolean {
  if (!user) {
    return false;
  }
  if (!isProd()) {
    return true;
  }
  if (user.roles?.includes(ROLE_REPORTING_ADMIN)) {
    return true;
  }
  return Boolean(user.email && pilot.has(user.email.trim().toLowerCase()));
}
